<template>
    <div class="main">
        <div class="siwper" style="position: relative;">
            <img src='~assets/image/solution-img/solution.png' />
        </div>
        <div class="about_content">
            <div class="left">
                <ul>
                    <li>智慧托盘</li>
                    <li :class="{active:currentIndex==index}" v-for="(item,index) in listData" :key="index" @click="changePall(index)">{{item.text}}</li>
                </ul>
            </div>
            <div class="news">
                <transition name="no-mode-fade" mode="out-in">
                    <component v-bind:is="currentTaskView"></component>
                </transition>
            </div>
        </div>
    </div>
</template>
<script>
import resolve from './resolve'
import sortware from './sortware'
import heSolution from './heSolution'

import smartStore from './smartStore'
import smartBeforeStore from './smartBeforeStore'

export default {
    components: {
        resolve,
        sortware,
        heSolution,
        smartStore,
        smartBeforeStore
    },
    data() {
        return {
            currentIndex: 0,
            defulat: true,
            currentTaskView: heSolution,
            listData: [{
                text: '硬件设备',
                url: 'heSolution'
            }, {
                text: '软件系统',
                url: 'sortware'
            }, {
                text: '解决方案',
                url: 'resolve'
            },
                {
                	text: '智能仓储',
                	url: 'smartStore'
                },
                {
                	text: '智能前置仓',
                	url: 'smartBeforeStore'
                }
            ]
        }
    },
    methods: {
        changePall(index) {
            this.currentIndex = index;
            this.currentTaskView = this.listData[index].url;
        }
    }
}
</script>

<style lang="less" scoped>
.no-mode-fade-enter-active,
.no-mode-fade-leave-active {
    transition: all 0.5s;
}
.no-mode-fade-enter,
.no-mode-fade-leave-active {
    opacity: 0;
}
.no-mode-fade-enter {
    transform: translateY(-51px);
}
.no-mode-fade-leave-active {
    transform: translateY(51px);
}
.main {
    margin-top: 20px;
    // background: #F6FAFB;
}

.siwper {
    width: 100%;
    img {
        width: 100%;
    }
}
.top {
    padding: 10px;
    background: #ff6d00;
    color: #fff;
    text-align: center;
    border-radius: 2px;
}
.about_content {
    display: flex;
    max-width: 1180px;
    min-width: 1080px;
    margin: 0 auto;
    .left {
        flex: 1.3;
        background: #fff;
        height: 336px;
        border-bottom: 5px solid #ff6d00;
        box-shadow: 1px 2px 12px #999;
        margin: 30px 0 30px 8px;
        ul {
            width: 100%;
            list-style: none;
            li {
                width: 100%;
                border-bottom: 1px solid #f1f1f1;
                height: 55px;
                line-height: 55px;
                text-align: center;
                font-size: 16px;
                cursor: pointer;
                background: url(~assets/image/palletimg/right.svg) no-repeat;
                background-position: 93% 18px;
                &:hover {
                    /*background: #eee;*/
                    background: #f3f3f3 url(~assets/image/palletimg/right.svg)
                        no-repeat;
                    background-position: 93% 18px;
                }
                a {
                    color: #444;
                }
            }
            li:last-child {
                // padding-left: 20px;
            }
            li:nth-child(1) {
                background: #ff6d00;
                color: #fff;
                font-size: 20px;
                font-weight: bold;
                text-align: center;
            }
        }
    }
    .news {
        flex: 5;
        overflow: hidden;
        padding-left: 30px;
    }
    .active {
        background: #eee url(~assets/image/palletimg/right.svg) no-repeat !important;
        background-position: 93% 18px !important;
        font-weight: bold;
    }
}
</style>